import { cn } from '@utils/helpers';
import { forwardRef, useCallback, useImperativeHandle, useState } from 'react';
import { useFragment } from 'react-relay';
import { priceInfoFragment } from './PriceInfo.relay';
import { PriceInfoBody, PriceInfoHeader } from './lib';
import type { PriceInfoPropsType, PriceInfoRef } from './types';

const PriceInfo = forwardRef<PriceInfoRef, PriceInfoPropsType>((props, ref) => {
  const component = useFragment(priceInfoFragment, props.component);
  const [priceinfosubscribed, setPriceinfosubscribed] = useState(component.checked);

  useImperativeHandle(
    ref,
    () => ({
      refs: {
        component: {
          state: { priceinfosubscribed },
        },
      },
    }),
    [priceinfosubscribed],
  );

  const changePriceInfoSubscription = useCallback((value: boolean) => {
    setPriceinfosubscribed(value);
  }, []);

  return (
    <table className={cn('Table Subscription-table PriceInfo mt-20 mb-10 w-full max-w-[1000px]', 'max-desktop:max-w-[565px]', 'max-[620px]:block max-[620px]:w-full max-[620px]:max-w-[calc(100vw-40px)]')}>
      <PriceInfoHeader tableheader={component.tableheader} />
      <PriceInfoBody title={component.title} checked={priceinfosubscribed} file={component.file} archive={component.archive} onCheckChange={changePriceInfoSubscription} />
    </table>
  );
});

export { PriceInfo };
